import type { PropsWithChildren } from 'react';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.min.css';

export function ToastProvider({ children }: PropsWithChildren<{}>) {
  return (
    <>
      {children}
      <ToastContainer position="bottom-right" limit={3} />
    </>
  );
}
